import React from 'react';

const ShippingPolicyComponent = () => {
    return (
        <section className="as_about_wrapper as_padderTop80 as_padderBottom80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <h1 className="as_heading text-center">Shipping Policy</h1>
                        <div className="as_font14 as_padderTop20" style={{lineHeight: '1.8'}}>
                            <div style={{backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #dee2e6'}}>
                                <h3 style={{color: '#495057', marginBottom: '15px', fontSize: '18px'}}>Shipping Information</h3>
                                <p style={{marginBottom: '0', textAlign: 'justify'}}>
                                    The orders for the user are shipped through registered domestic courier companies and/or speed post only. 
                                    Ordered product will be delivered within <strong>5 to 10 working days</strong> from the date of the order and/or payment 
                                    or as per the delivery date agreed at the time of order confirmation and delivering of the shipment, subject to courier company / post office norms. 
                                </p>
                                <p style={{marginTop: '15px', marginBottom: '0', textAlign: 'justify'}}>
                                    Platform Owner shall not be liable for any delay in delivery by the courier company / postal authority. 
                                    Delivery of all orders will be made to the address provided by the buyer at the time of purchase. 
                                    Delivery of our services will be confirmed on your email ID as specified at the time of registration. 
                                    If there are any shipping cost(s) levied by the seller or the Platform Owner (as the case be), the same is not refundable.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShippingPolicyComponent; 